import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

const ServiceStruct = () => {
  return (
    <section className="py-5 service-section">
      <Container style={{ maxWidth: "80%", margin: "0 auto" }}>
        <Row className="align-items-center">
          <Col xs={12} md={6} className="text-center mb-4 mb-md-0">
            <motion.img
              src={require("../../static/media/service/service1.webp")}
              alt="Desarrollo Web y Aplicaciones"
              className="img-fluid service-img"
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.3 }}
            />
          </Col>

          <Col xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <h2 className="fw-bold service-title mb-4">
                Desarrollo Web y Aplicaciones
              </h2>
              <p className="service-text">
                En <strong>CMSOLTEC</strong> nos especializamos en el desarrollo de sitios web, aplicaciones y software a medida. Utilizamos tecnologías modernas y robustas, integrando Python con bases de datos como PostgreSQL y entornos dinámicos como React, para crear plataformas seguras, escalables y eficientes. Digitalizamos procesos y diseñamos interfaces intuitivas enfocadas en una experiencia de usuario óptima, brindando atención personalizada desde nuestra sede en Quito para clientes en toda la región.
              </p>
            </motion.div>
          </Col>
        </Row>
      </Container>

      <style>
        {`
          .service-section {
            background: linear-gradient(90deg, #333 0%, #000 50%, #333 100%);
          }
          .service-section .service-title {
            font-size: 1.2rem;
            color: #ff6600;
            margin-bottom: 0.3rem;
          }
          .service-section .service-text {
            font-size: 0.8rem;
            line-height: 1.7;
            color: #f8f9fa;
            text-align: justify;
            margin-bottom: 1rem;
          }
          .service-section .service-img {
            border-radius: 12px;
            max-width: 90%;
            height: auto;
            background-color: #fff;
            padding: 8px;
          }

          @media (min-width: 576px) {
            .service-section .service-title {
              font-size: 1.5rem !important;
            }
            .service-section .service-text {
              font-size: 0.9rem !important;
            }
          }

          @media (min-width: 992px) {
            .service-section .service-title {
              font-size: 2rem !important;
            }
            .service-section .service-text {
              font-size: 1rem !important;
            }
            .service-section .service-img {
              max-width: 70% !important;
            }
          }

          @media (max-width: 576px) {
            .service-section .service-img {
              max-width: 80% !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default ServiceStruct;